import groupBy from "lodash.groupby";
import meanBy from "lodash.meanby";
import orderBy from "lodash.orderby";
import startCase from "lodash.startcase";

import { PluginPerformanceType } from "@intelligems/ig-types";
import { ensureNumber, roundDownToXMinutes } from "@intelligems/ig-utils";

const keys = [
  "TTFB",
  "startRender",
  "FCP",
  "speedIndex",
  "LCP",
  "TBT",
  "cpuTime",
];

export const formatPerformanceData = (
  input: PluginPerformanceType[],
  minutes: number
): PluginPerformanceType[] => {
  const blockedData = orderBy(
    input.map((event) => {
      const key = event.blockIntelligems ? "-blocked" : "";
      return {
        ...event,
        results: Object.entries(event.results || {}).reduce(
          (prev, [curKey, curValue]) => {
            return {
              ...prev,
              [`${curKey}${key}`]: curValue,
            };
          },
          {}
        ),
        completed:
          roundDownToXMinutes((event.completed || 0) * 1000, minutes) / 1000,
      };
    }),
    (_) => _.completed
  );

  const groupedData = groupBy(blockedData, (_) => _.completed);
  const finalData: PluginPerformanceType[] = [];

  for (const [key, values] of Object.entries(groupedData)) {
    for (const b of [true, false]) {
      const k = b ? "-blocked" : "";
      const valuesToUse = values.filter((v) => v.blockIntelligems === b);
      if (valuesToUse.length) {
        finalData.push({
          ...valuesToUse[0],
          results: keys.reduce((prev, curr) => {
            return {
              ...prev,
              [`${curr}${k}`]: meanBy(
                valuesToUse.map((r) => r.results),
                (_) => _[`${curr}${k}`]
              ),
            };
          }, {}),
        });
      }
    }
  }

  return finalData;
};

const names = {
  TTFB: "Time to First Byte (ms)",
  startRender: "Start Render (ms)",
  FCP: "First Contentful Paint (ms)",
  speedIndex: "Speed Index (ms)",
  LCP: "Largest Contentful Paint (ms)",
  TBT: "Total Blocking Time (ms)",
  cpuTime: "CPU Time (ms)",
};

export const titleFormatter = (key: string, long: boolean) => {
  if (long) {
    return names[key.replace("-blocked", "")] || "";
  }
  return startCase(key);
};

export const dataFormatter = (key: string, value: number) => {
  return `${ensureNumber(value).toFixed(2)} ms`;
};
